import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Work from "../components/Work";
import Ethos from "../components/Ethos";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div>
      <Nav />
      <main>
        <Hero />
        <Work />
        <Ethos />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
